import { stateMeta } from "../format";
import type { AvailabilityState } from "../types";

export function StatusBadge({
  state,
  compact = false,
}: {
  state: AvailabilityState;
  compact?: boolean;
}) {
  const meta = stateMeta[state];
  return (
    <span className={`status-badge state-${state}`} data-state={state}>
      <b aria-hidden="true">{meta.symbol}</b>
      {compact ? meta.shortLabel : meta.label}
    </span>
  );
}
